/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  Types,
  IDashboardState,
  IDuplicateData,
  IOpenOrderStatusData,
  IBilledMonthData,
  IPaidByMonthData,
  IBilledByDayData,
  IDuplicatesByDayData,
  IOpenOrderStatusDataBySku,
  IDuplicatesByDayState,
  IBilledByDayState
} from './types';
import { Reducer } from 'redux';
import moment from 'moment';

const INITIAL_STATE: IDashboardState = {
  selectedCustomerId: ''
};

type CustomAction = {
  type: Types;
  payload: {
    selectedCustomerId: string;
    invoicesSummary: IDuplicateData;
    billedByDayMonthDate: moment.Moment;
    duplicatesByDayMonthDate: moment.Moment;

    billedMonthData: IBilledMonthData[];
    paidMonthData: IPaidByMonthData[];
    openOrderStatus: IOpenOrderStatusData[];
    openOrderStatusBySku: IOpenOrderStatusDataBySku[];
    billedByDayData: IBilledByDayData[];
    duplicatesByDayData: IDuplicatesByDayData[];
    lastUpdateMoment: moment.Moment;
  };
};

const reducer: Reducer<IDashboardState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    // Volume de pedido por status
    case Types.LOAD_OPEN_ORDER_STATUS:
      return {
        ...state,
        selectedCustomerId: action.payload.selectedCustomerId,
        openOrderStatus: {
          loading: true,
          error: false,
          dashboard: [],
          lastUpdateMoment: undefined
        }
      };
    case Types.LOAD_OPEN_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        openOrderStatus: {
          loading: false,
          error: false,
          dashboard: action.payload.openOrderStatus,
          lastUpdateMoment: action.payload.lastUpdateMoment
        }
      };
    case Types.LOAD_OPEN_ORDER_STATUS_FAILURE:
      return {
        ...state,
        openOrderStatus: { loading: false, error: true, dashboard: [] }
      };

    case Types.LOAD_OPEN_ORDER_STATUS_BY_SKU:
      return {
        ...state,
        selectedCustomerId: action.payload.selectedCustomerId,
        openOrderStatus: {
          ...state.openOrderStatus!,
          loadingBySku: true,
          erroBySku: false,
          dashboardBySku: [],
          lastUpdateMomentBySku: undefined
        }
      };
    case Types.LOAD_OPEN_ORDER_STATUS_BY_SKU_SUCCESS:
      return {
        ...state,
        openOrderStatus: {
          ...state.openOrderStatus!,
          loadingBySku: false,
          erroBySku: false,
          dashboardBySku: action.payload.openOrderStatusBySku,
          lastUpdateMomentBySku: action.payload.lastUpdateMoment
        }
      };
    case Types.LOAD_OPEN_ORDER_STATUS_BY_SKU_FAILURE:
      return {
        ...state,
        openOrderStatus: {
          ...state.openOrderStatus!,
          loadingBySku: false,
          erroBySku: true
        }
      };

    case Types.LOAD_BILLED_BY_MONTH:
      return {
        ...state,
        selectedCustomerId: action.payload.selectedCustomerId,
        billedByMonth: { loading: true, error: false, data: [] }
      };
    case Types.LOAD_BILLED_BY_MONTH_SUCCESS:
      return {
        ...state,
        billedByMonth: {
          loading: false,
          error: false,
          data: action.payload.billedMonthData
        }
      };
    case Types.LOAD_BILLED_BY_MONTH_FAILURE:
      return {
        ...state,
        billedByMonth: { loading: false, error: true, data: [] }
      };

    case Types.LOAD_PAID_BY_MONTH:
      return {
        ...state,
        selectedCustomerId: action.payload.selectedCustomerId,
        paidByMonth: { loading: true, error: false, data: [] }
      };
    case Types.LOAD_PAID_BY_MONTH_SUCCESS:
      return {
        ...state,
        paidByMonth: {
          loading: false,
          error: false,
          data: action.payload.paidMonthData
        }
      };
    case Types.LOAD_PAID_BY_MONTH_FAILURE:
      return {
        ...state,
        paidByMonth: { loading: false, error: true, data: [] }
      };

    case Types.LOAD_DUPLICATES:
      return {
        ...state,
        selectedCustomerId: action.payload.selectedCustomerId,
        duplicates: { loading: true, error: false }
      };
    case Types.LOAD_DUPLICATES_SUCCESS:
      return {
        ...state,
        duplicates: {
          loading: false,
          error: false,
          invoicesSummary: action.payload.invoicesSummary
        }
      };
    case Types.LOAD_DUPLICATES_FAILURE:
      return { ...state, duplicates: { loading: false, error: true } };

    case Types.LOAD_BILLED_BY_DAY:
      return {
        ...state,
        selectedCustomerId: action.payload.selectedCustomerId,
        billedByDay: {
          loading: true,
          error: false,
          data: [],
          monthDate: action.payload.billedByDayMonthDate
        }
      };
    case Types.LOAD_BILLED_BY_DAY_SUCCESS:
      return {
        ...state,
        billedByDay: {
          ...(state.billedByDay as IBilledByDayState),
          loading: false,
          error: false,
          data: action.payload.billedByDayData
        }
      };
    case Types.LOAD_BILLED_BY_DAY_FAILURE:
      return {
        ...state,
        billedByDay: {
          ...(state.billedByDay as IBilledByDayState),
          loading: false,
          error: true,
          data: []
        }
      };

    case Types.LOAD_DUPLICATES_BY_DAY:
      return {
        ...state,
        selectedCustomerId: action.payload.selectedCustomerId,
        duplicatesByDay: {
          loading: true,
          error: false,
          data: [],
          monthDate: action.payload.duplicatesByDayMonthDate
        }
      };
    case Types.LOAD_DUPLICATES_BY_DAY_SUCCESS:
      return {
        ...state,
        duplicatesByDay: {
          ...(state.duplicatesByDay as IDuplicatesByDayState),
          loading: false,
          error: false,
          data: action.payload.duplicatesByDayData
        }
      };
    case Types.LOAD_DUPLICATES_BY_DAY_FAILURE:
      return {
        ...state,
        duplicatesByDay: {
          ...(state.duplicatesByDay as IDuplicatesByDayState),
          loading: false,
          error: true,
          data: []
        }
      };

    case Types.CLEAN_DASHBOARD:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
};

export default reducer;
